module.exports = __webpack_public_path__ + "static/media/ic-nica-logo-large-knockout.04c80b01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ic-nica-logo-large-knockout.svg
// module id = 784
// module chunks = 0